import React from 'react'
import styles from './style.module.scss';
import Modal from '../../../../../../../../../../components/modal';
import Button from '../../../../../../../../../../components/new-button';

const ConfirmPdfModal = ({ isOpen, onClose, consentPdfStatus, submitApplication }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header="Confirm PDF"
      size="md"
    >

      <div className={styles.body}>
        Your agent has requested you to sign{" "}
        {consentPdfStatus.totalPdf} processor
        application(s), you have chosen to sign only{" "}
        {consentPdfStatus.viewedPdf} application(s),
        please confirm before continuing.
      </div>
      <footer className={styles.footer}>
        <Button
          variant="primary"
          onClick={() => {
            submitApplication();
          }}
        >
          Continue
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            onClose();
          }}
        >
          Cancel
        </Button>
      </footer>

    </Modal>
  )
}

export default ConfirmPdfModal;